<template>
  <div>
    <el-table v-loading="loading" :data="tableData" border style="width: 100%" show-summary :summary-method="getSummaries">
      <el-table-column type="index" width="70" label="序号" align="left" fixed="left" />
      <el-table-column prop="teleNum" label="电汇底单编号" align="left" />
      <el-table-column prop="contractSum" label="订单金额" align="right" header-align="left" width="150px" />
      <el-table-column prop="assignAmount" label="已分配金额" align="right" header-align="left" width="150px" />
      <el-table-column prop="usedScale" label="分配金额比例" align="right" header-align="left" width="150px" />
      <el-table-column prop="createdBy" label="分配人" align="left" />
      <el-table-column prop="createdTime" label="分配日期" align="left" />
      <!--已抛到erp的合同，不允许撤销已分配的款项-->
      <!-- <el-table-column label="操作" align="left">
        <template slot-scope="scope">
          <el-button v-if="scope.row.buttonState === null && $route.query.distributeFlag" type="text" size="small" @click="cancelAllocation(scope.row)">
            撤销分配
          </el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 撤销原因 -->
    <el-dialog v-if="causeRevocationVisible" title="撤销原因" :visible.sync="causeRevocationVisible" width="800px" @close="close">
      <el-input v-model="causeRevocation" type="textarea" maxlength="100" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="cancel">取消申请</el-button>
        <el-button type="primary" :loading="submitLoading" @click="onSubmit">提交申请</el-button>
      </span>
    </el-dialog>
    <!-- 查看 -->
    <el-dialog v-if="examineVisible" title="合同基本信息" :visible.sync="examineVisible" width="800px">
      <examine :id="approvalNumID" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="examineVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="es6">
import { selectInterByContractId, canclePayMoney, undoDistributionAgree } from '@/API';
import { MathAdd, numDiv } from '@/libs/util';
export default {
  components: {
  },
  props: {
    contractId: {
      type: [String, Number],
      required: true
    },
    contractStatus: {
      type: [String, Number],
      required: true
    },
    isCanclePayMoney: {
      type: Boolean,
      default: true
    },
    // 合同信息中需要塞进去的字段
    infoTableData: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      tableData: [],
      loading: false,
      refundDetail: [],
      causeRevocation: '', // 撤销原因
      causeRevocationVisible: false,
      examineVisible: false,
      approvalNumID: 0,
      postData: {},
      submitLoading: false
    };
  },

  computed: {
    allAssignAmount () {
      let cont = 0;
      this.tableData.forEach((item) => {
        cont = MathAdd(cont, item.assignAmount);
      });
      return cont.toFixed(2);
    }
  },

  mounted () {
    this.initData();
  },

  methods: {
    initData () {
      this.loading = true;
      selectInterByContractId(this.contractId).then(res => {
        this.loading = false;
        console.log(res);
        if (res.data.status === '200') {
          console.log('infoTableData', this.infoTableData.orderMoney);
          // contractSum 订单金额
          let addMapTableData = res.data.data.map(item => {
            let params = {
              ...item,
              contractSum: this.infoTableData.orderMoney

            };
            return params;
          });
          console.log('addMapTableData', addMapTableData);
          this.tableData = addMapTableData;
        }
      });
    },

    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '订单金额' && this.tableData.length) {
          sums[index] = this.tableData[0].contractSum;
          return;
        }
        if (column.label === '已分配金额') {
          sums[index] = this.allAssignAmount;
          return;
        }
        if (column.label === '分配金额比例' && this.tableData.length) {
          let pre = (numDiv(this.allAssignAmount * 100, this.tableData[0].contractSum)).toFixed(2);
          sums[index] = `${pre}%`;
        }
      });
      return sums;
    },
    canclePayMoney (row) {
      this.loading = true;
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        canclePayMoney(row.contractAssignId).then((res) => {
          this.loading = false;
          if (res.status === 200) {
            this.$message({
              type: 'success',
              message: '成功撤销!'
            });
            this.initData();
          }
        }).catch(() => {
          this.loading = false;
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消撤销操作！'
        });
        this.loading = false;
      });
    },
    cancelAllocation (row) {
      this.causeRevocationVisible = true;
      this.postData.ids = [row.contractAssignId];
    },
    showDetail (val) {
      this.approvalNumID = val.contractAssignId;
      this.examineVisible = true;
    },
    onSubmit () {
      if (!this.causeRevocation) {
        this.$message.warning('撤销原因不能为空');
        return;
      }
      this.postData.type = 1;
      let type = this.$route.query.type ? this.$route.query.type : 1;
      this.postData.type = type;
      this.postData.reason = this.causeRevocation;
      this.submitLoading = true;
      undoDistributionAgree(this.postData).then((res) => {
        this.submitLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.$message({
            type: 'success',
            message: '成功撤销!'
          });

          this.initData();
          this.close();
        }
      }).catch(() => {
        this.submitLoading = false;
      });
    },
    cancel () {
      this.causeRevocationVisible = false;
      this.causeRevocation = '';
    },
    close () {
      this.cancel();
    }
  }

};
</script>

<style scoped>
.title{
  padding: 10px 0;
}
</style>
